import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import type { IRootStore } from '../stores';

/**
 * Hook replacement for mobx-react's `inject`.
 *
 * Returns the root store provided via `<Provider store={store}>` in index.js.
 * Components call this inside their function body and inline the mapper logic
 * that used to live in the `inject(({ store }) => ...)` wrapper.
 *
 * `<Provider>` stays untouched; mobx-react 9 ships `MobXProviderContext` and the
 * store is exposed under the `store` key (see useVisibleFSM.js for the same
 * pattern).
 */
export function useStores(): IRootStore {
  // `MobXProviderContext` is typed `Record<string, any>` by mobx-react, so the
  // `store` value is `any`; narrow it to the concrete RootStore once here.
  return useContext(MobXProviderContext).store as IRootStore;
}
